// Tiny pub/sub used by the web bridge to mirror the Electron
// ipcRenderer.on(...) channels the renderer subscribes to (script:loaded,
// folder:loaded, backup:status, update:status, auth:callback-complete,
// menu:*, and the test:* handshake events).

export function createEventBus() {
  const target = new EventTarget();
  return {
    on(channel, cb) {
      const handler = (e) => cb(e.detail);
      target.addEventListener(channel, handler);
      return () => target.removeEventListener(channel, handler);
    },
    emit(channel, payload) {
      target.dispatchEvent(new CustomEvent(channel, { detail: payload }));
    },
  };
}
